import { render, staticRenderFns } from "./RevCompletedModal.vue?vue&type=template&id=643a3bb4"
import script from "./RevCompletedModal.vue?vue&type=script&lang=js"
export * from "./RevCompletedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports